// Sets path / pageLabel / default mode from react-router on every navigation, independent of chat.
// Also resets `surfaces` to a generic placeholder so a previous page's surfaces never linger; pages
// that contribute richer surfaces re-publish via useRegisterUIContext. This effect runs BEFORE the
// page's register effect (the bridge is rendered before the page <Outlet/>), so the page wins.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { setUIContext } from '@/redux/slices/uiContextSlice';
import { routeMetaFor } from '@/utils/constants/routeLabels';

export function useRouteUIContext(): void {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  useEffect(() => {
    const { label, mode } = routeMetaFor(pathname);
    dispatch(setUIContext({ path: pathname, pageLabel: label, mode, surfaces: [{ kind: 'generic' }] }));
  }, [dispatch, pathname]);
}
